import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, reactive, toRaw, computed, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import { goBack } from '@/hooks/cosRouter'
import { message } from '@dc-platform/dc-components'
import { DropListType } from '@/typings/common'
import { selectForNumberValidate } from '@/utils/validate'
import { MarketingManageEditParams } from '@/typings/api/marketingManage'
import { parentLabelList, tagsManageAdd, tagsManageEdit, tagsManageDetails } from '@/api/marketing/marketingManage'
import type { SelectProps, FormInstance } from 'ant-design-vue'

const __default__ = { name: 'DetailForm' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: {},
    type: {},
    subdomain: {},
    title: {}
  },
  setup(__props: any) {

const route = useRoute()

const props = __props

const typeEnum = ref<SelectProps['options']>([{ value: 1, label: '静态标签' }])
const permissionPage = computed(() => {
  const addPermissions = {
    fbu: { save: 'fbu_tags_add_btn' },
    lbu: { save: 'lbu_tags_add_btn' }
  }
  const otherPermissions = {
    fbu: { edit: 'fbu_tags_edit_btn', save: 'fbu_tags_edit_btn' },
    lbu: { edit: 'lbu_tags_edit_btn', save: 'lbu_tags_edit_btn' }
  }
  return props.type === 'add' ? addPermissions[props.subdomain] : otherPermissions[props.subdomain]
})

const initForm = reactive<MarketingManageEditParams>({
  name: undefined,
  parentId: undefined,
  type: 1,
  remark: undefined
})
const formRef = ref<FormInstance>()
const dataForm = reactive<MarketingManageEditParams>(cloneDeep(initForm))
const formRules = reactive({
  name: [{ required: true, message: '请输入标签名称' }],
  type: [{ required: true, validator: selectForNumberValidate, message: '请选择标签类型' }]
})

const queryId = computed(() => route.query.id as string)
const parentLabelEnum = ref<DropListType>([])
const getParentLabel = () => {
  const params: { id?: number } = {}
  if (queryId.value) params.id = parseInt(queryId.value)
  parentLabelList(params).then((res) => {
    parentLabelEnum.value = res.data
  })
}
const loading = ref(false)
const getTagsDetails = () => {
  loading.value = true
  tagsManageDetails({ id: queryId.value })
    .then((res) => {
      Object.assign(dataForm, res.data)
      Object.assign(initForm, res.data)
    })
    .finally(() => {
      loading.value = false
    })
}
onBeforeMount(() => {
  getParentLabel()
  if (props.type !== 'add') {
    getTagsDetails()
  }
})

const submitTagsAdd = () => {
  loading.value = true
  tagsManageAdd(toRaw(dataForm))
    .then(() => {
      message.success('新增标签成功')
      goBack()
    })
    .finally(() => {
      loading.value = false
    })
}
const submitTagsEdit = () => {
  loading.value = true
  tagsManageEdit(toRaw(dataForm))
    .then(() => {
      message.success('修改标签成功')
      goBack()
    })
    .finally(() => {
      loading.value = false
    })
}

const onSubmit = () => {
  if (props.type === 'add') {
    submitTagsAdd()
  } else if (props.type === 'edit') {
    submitTagsEdit()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      model: dataForm,
      rules: formRules,
      autocomplete: "off",
      scrollToFirstError: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, {
          title: props.title,
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "标签名称",
              name: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.name) = $event)),
                  maxlength: 100,
                  placeholder: "请输入标签名称",
                  disabled: props.type === 'view',
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "上级标签",
              name: "parentId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  fieldNames: { label: 'name', value: 'id' },
                  value: dataForm.parentId,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.parentId) = $event)),
                  placeholder: "请选择上级标签",
                  allowClear: "",
                  disabled: props.type === 'view',
                  view: props.type === 'view',
                  options: parentLabelEnum.value
                }, null, 8, ["value", "disabled", "view", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "标签类型",
              name: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: dataForm.type,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.type) = $event)),
                  options: typeEnum.value,
                  placeholder: "请选择标签类型",
                  disabled: props.type === 'view',
                  view: props.type === 'view'
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              label: "备注",
              name: "remark",
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: dataForm.remark,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.remark) = $event)),
                  maxlength: 2000,
                  disabled: props.type === 'view',
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_cos_footer_button, {
      value: dataForm,
      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dataForm) = $event)),
      formRef: formRef.value,
      resetValue: initForm,
      loading: loading.value,
      disabled: props.type === 'view',
      permissionPage: permissionPage.value,
      editUrl: `/${props.subdomain}/tagsManage/edit?id=${queryId.value}`,
      onSubmit: onSubmit
    }, null, 8, ["value", "formRef", "resetValue", "loading", "disabled", "permissionPage", "editUrl"])
  ], 64))
}
}

})